import { useCallback } from 'react'
import { useCreateDocumentVersionSessionEvent } from '@/services/queries/document_sessions'
import { useUpdateDocumentVersionSessionEvent } from '@/services/queries/document_sessions'
import { useTechnicianPageStore } from './useTechnicianPageStore'

export const useCreateSessionEvent = () => {
  const { mutateAsync: createEvent } = useCreateDocumentVersionSessionEvent()
  const { mutateAsync: updateEvent } = useUpdateDocumentVersionSessionEvent()

  const currentSessionId = useTechnicianPageStore(
    (state) => state.currentSessionId,
  )

  const lastSessionEventId = useTechnicianPageStore(
    (state) => state.lastSessionEventId,
  )

  const createSessionEvent = useCallback(
    async ({
      documentPageId,
      buttonLabel,
      completeLastEvent = true,
      completedTimestamp,
      subPageIndex,
      onSuccess,
    }: {
      documentPageId: string
      buttonLabel: string
      completeLastEvent?: boolean
      completedTimestamp?: string
      subPageIndex?: number
      onSuccess?: () => void
    }) => {
      const shouldCompleteEvent =
        lastSessionEventId && completeLastEvent && !completedTimestamp

      if (currentSessionId) {
        // Create the next event and complete the previous one in order so the
        // store and backend stay in sync while users move quickly through pages.
        await createEvent({
          documentPageId,
          documentVersionSessionId: currentSessionId,
          buttonLabel,
          completedTimestamp,
          subPageIndex,
        })

        if (shouldCompleteEvent) {
          await updateEvent({
            documentVersionSessionEventId: lastSessionEventId,
            completedTimestamp: new Date().toISOString(),
            subPageIndex,
          })
        }

        if (typeof onSuccess === 'function') {
          onSuccess()
        }
      }
    },
    [createEvent, currentSessionId, lastSessionEventId, updateEvent],
  )

  return {
    createSessionEvent,
  }
}
